import React, { useState, useEffect } from "react";
import { Header_panel, ModalDetailUser } from "../Useful/Useful";
import "./user.css";
import TablePagination from "@material-ui/core/TablePagination";
import CloseRoundedIcon from '@material-ui/icons/CloseRounded';
import { IndustrialUnitGetByTown, ChangeIndustrialManager, SearchByPhoneNumber } from "../../fetch";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import SearchRoundedIcon from '@material-ui/icons/SearchRounded';
import { Switch, Modal } from "@material-ui/core";
import { Link } from "react-router-dom";
import { Button } from "reactstrap";
import Spinner from "react-bootstrap/Spinner";
import EditUser from "./EditUser";
import { useHistory } from "react-router-dom";
import Addimage from "../../image-add.png";

import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import CircularProgress from '@material-ui/core/CircularProgress';
import IconButton from "@material-ui/core/IconButton";
import { FcFullTrash, FcInspection } from "react-icons/fc";

export default function User_list(props) {
  const [flag, setflag] = useState(false);
  const [navid, setnavid] = useState("#navbarToggleExternalContentSettingAdd1");
  const history = useHistory();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [SearchPhoen, setSearchPhoen] = useState(null);
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [rowslength, setrowslength] = useState(0);
  const [render, setrender] = useState(false);
  const [id, setId] = useState("");
  const town = JSON.parse(sessionStorage.getItem("town"));
  const [SearchID, setSearchID] = useState(null);
  const [SelecredTown, setSelecredTown] = useState(null);
  const [PhoneResult, setPhoneResult] = useState([])
  const [Searching, setSearching] = useState(false);
  const [SearchLoading, setSearchLoading] = useState(false);
  const [ShowChangeUnitone, setShowChangeUnitone] = useState(false);
  const [ShowChangeUnittwo, setShowChangeUnittwo] = useState(false);
  useEffect(() => {
    getsettings();
  }, []);
  useEffect(() => {
    getsettings();
  }, [page, rowsPerPage]);
  const scrollBackToTop = () => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  };

  const handleSearchByPhone = () => {
    setSearchLoading(true)
    if (SearchPhoen === null) {
      toast.error("لطفا شماره تماس مورد نظر را وارد کنید")
      setSearchLoading(false)
    } else {
      SearchByPhoneNumber(SearchPhoen)
        .then((response) => {
          return response.json();
        })
        .then((responseJson) => {
          if (!responseJson.success) {
            toast.error(responseJson.message);
            setSearching(true);
            setSearchLoading(false)
          } else {
            // toast.success(responseJson.message);
            setSearching(true);
            setSearchLoading(false)
            setPhoneResult(responseJson?.result);
            // console.log("this is data : " + JSON.stringify(responseJson?.result))
            return true;
          }
        })
        .catch((error) => {
          console.error(error);
          toast.error("خطای ارتباط با سرور");
          setSearchLoading(false)
          return false;
        });
    }
  }

  const handleSaveSearchtwo = () => {
    setSearchLoading(true)
    if (SearchID === null) {
      toast.error("لطفا شماره تماس مورد نظر را انتخاب کنید")
      setSearchLoading(false)
    } else {
      ChangeIndustrialManager({
        IndustrialUnitId: SelecredTown,
        UserId: SearchID
      })
        .then((response) => {
          return response.json();
        })
        .then((responseJson) => {
          if (!responseJson.success) {
            toast.error(responseJson.message);
            setSearching(true);
            return false;
            setSearchLoading(false)
          } else {
            toast.success(responseJson.message);
            setSearching(true);
            setShowChangeUnitone(false)
            setSearchLoading(false)
            // console.log("this is data : " + JSON.stringify(responseJson?.result))
            return true;
          }
        })
        .catch((error) => {
          console.error(error);
          toast.error("خطای ارتباط با سرور");
          setSearchLoading(false)
          return false;
        });
    }
  }

  const getsettings = () => {
    setLoading(true);
    IndustrialUnitGetByTown(props.match.params.id)
      .then((response) => {
        setLoading(false);

        return response.json();
      })
      .then((responseJson) => {
        setRows(responseJson.result);

        setrowslength(responseJson.count);
      })
      .catch((error) => {
        setLoading(false);
        console.log(error);
      });
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // const handleChange = (name) => (event) => {
  //   const data = { id: event.target.value, isActive: event.target.checked };
  //   UserconfirmGet(data)
  //     .then((response) => {
  //       return response.json();
  //     })
  //     .then((responseJson) => {
  //       if (responseJson.status === 400) {
  //         toast.error(responseJson.message);
  //       } else if (responseJson.success === true) {
  //         toast.success(responseJson.message);
  //       }

  //       const idx = rows.findIndex(
  //         (rows) => rows.id === responseJson.result.id
  //       );
  //       rows.splice(idx, 1, responseJson.result);
  //       setrender(!render);
  //       setrender(!render);
  //     })
  //     .catch((error) => {
  //       setLoading(false);
  //       console.log(error);
  //     });
  // };

  return (
    <div>
      <div class="col-12 mypanel shadow">
        <Header_panel
          title="لیست واحدهای صنعتی"
          idMenu="#navbarToggleExternalContentUserList"
        />
        <div className="d-flex justify-content-center">
          {loading && (
            <>
              <Spinner animation="grow" variant="info" size="lg" />
              <div> صفحه در حال بارگزاری است ...</div>
            </>
          )}
        </div>
        <div class="pos-f-t">
          <div class="collapse" id="navbarToggleExternalContentUserList">
            <div class="p-4 mytable">
              <table class="table table-striped rtltable">
                <thead>
                  <tr>
                    <th> ردیف</th>
                    <th> عکس</th>
                    <th> نام واحد</th>
                    {/* <th> کاربر </th> */}
                    <th> مدیر عامل</th>
                    <th> شماره تماس</th>
                    {/* <th> وضعیت</th>
                    <th> دسترسی</th> */}
                    <th>جایگزین</th>
                    <th> جزییات</th>
                    {/* <th> ارسال پیام</th> */}
                  </tr>
                </thead>

                <tbody>
                  {rows &&
                    rows
                      // .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                      .map((item, index) => {
                        return (
                          <tr>
                            <td>{page * rowsPerPage + index + 1}</td>
                            <td>
                              {" "}
                              {item.imageUrl ? (
                                <img
                                  src={`https://macks-b.ir/${item.imageUrl}`}
                                  alt="raeen"
                                  width="80"
                                />
                              ) : (
                                <img src={Addimage} alt="NoImage" width="80" />
                              )}
                            </td>
                            <td>{item.name}</td>
                            <td>{item.managingDirector}</td>

                            <td>{item.tell}</td>
                            {/* <td>
                            {item.block ? (
                              <CheckCircleOutlineIcon
                                style={{ color: "green", cursor: "pointer" }}
                                onClick={() => handleBlock(item.id)}
                              />
                            ) : (
                              <HighlightOffIcon
                                style={{ color: "red", cursor: "pointer" }}
                                onClick={() => handleUnBlock(item.id)}
                              />
                            )}
                          </td> */}
                            <td>
                              <a onClick={() => { setShowChangeUnitone(true); setSelecredTown(item?.id) }}>
                                <p style={{ fontSize: "16px", fontWeight: "bold", color: "#b39ddb", cursor: "pointer" }}> مدیریت واحد صنعتی</p>
                              </a>
                            </td>
                            <td>
                              <ModalDetailUser
                                buttonLabel="مشاهده"
                                title="مشاهده جزئیات"
                                address={
                                  item.address
                                    ? item.address
                                    : "آدرس ثبت نشده است"
                                }
                                activityType={
                                  item.activityType
                                    ? item.activityType
                                    : "  نوع فعالیت ثبت نشده است"
                                }
                                companyCode={
                                  item.companyCode
                                    ? item.companyCode
                                    : "   شناسه شرکت ثبت نشده است"
                                }
                                economicCode={
                                  item.economicCode
                                    ? item.economicCode
                                    : "   شناسه اقتصادی ثبت نشده است"
                                }
                                description={
                                  item.description
                                    ? item.description
                                    : "توضیحات  ثبت نشده است"
                                }
                                otherDatas={
                                  item.otherDatas_Json
                                    ? item.otherDatas_Json
                                    : []
                                }
                                managerName={
                                  item.managerName
                                    ? item.managerName
                                    : "نام ادمین  ثبت نشده است"
                                }
                                managerMobile={
                                  item.managerMobile
                                    ? item.managerMobile
                                    : "موبایل ادمین  ثبت نشده است"
                                }
                              ></ModalDetailUser>
                            </td>
                            {/* <td>
                            <Link to={`message/${item.id}`}>
                              <Button
                                color="success"
                                id="regDelbtn"
                                // onClick={() => { this.handleDelete(item.id) }}
                              >
                                {" "}
                                <SmsIcon />
                              </Button>
                            </Link>
                          </td> */}

                            {/* <td> {row.name}</td>
                          <td> {row.phonenumber}</td>
                          <td>
                            <ModalDetailUser
                              buttonLabel="اطلاعات بیشتر"
                              title="اطلاعات بیشتر"
                              address={
                                row.address ? row.address : "آدرس ثبت نشده است"
                              }
                              postalCode={
                                row.postalCode
                                  ? row.postalCode
                                  : "کدپستی ثبت نشده است"
                              }
                              province={
                                row.province
                                  ? row.province
                                  : "استان ثبت نشده است"
                              }
                              city={row.city ? row.city : "شهر ثبت نشده است"}
                            ></ModalDetailUser>
                          </td>

                          <td>
                            <Switch
                              color="primary"
                              checked={row.isActive}
                              onChange={handleChange("isActive")}
                              name="isActive"
                              value={row.id}
                              inputProps={{
                                "aria-label": "primary  checkbox",
                              }}
                            />
                          </td>
                          <td>
                            <Link to={`/main/user/${row.id}`}>
                              <IconButton
                                data-toggle="collapse"
                                data-target={!flag ? navid : ""}
                                color="primary"
                                onClick={() => {
                                  scrollBackToTop();
                                  setId(row.id);
                                  setflag(true);
                                }}
                              >
                                <FcInspection />
                              </IconButton>
                            </Link>
                          </td>
                          <td>
                            <IconButton onClick={() => hendleDelet(row.id)}>
                              <FcFullTrash />
                            </IconButton>
                          </td> */}
                          </tr>
                        );
                      })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <Modal
        open={ShowChangeUnitone}
        onClose={() => setShowChangeUnitone(false)}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
        <div className="changeUnitModal">
          <div className="container row">
            <div style={{ float: "left", textAlign: "left" }} className="col-lg-6">
              <IconButton onClick={() => setShowChangeUnitone(false)} className="CloseBtnModal" >
                <CloseRoundedIcon />
              </IconButton>
            </div>
            <div style={{ float: "right", textAlign: "right" }} className="col-lg-6">
              <h4 className="ModalTitle">جایگزین مدیریت واحد صنعتی</h4>
            </div>
            <div className="container row col-lg-12">
              <div className="col-lg-1">
                <IconButton onClick={() => handleSearchByPhone()} className="SearchBtnModal">
                  <SearchRoundedIcon />
                </IconButton>
              </div>
              <div className="col-lg-11">
                <input onChange={(e) => setSearchPhoen(e.target.value)} type="number" placeholder="... جستجو با شماره تماس" className="ModalSearch" />
              </div>
            </div>
            <div style={{ width: "100%" }}>
              <div className="MainReslut" style={{ marginTop: "30px" }}>
                {
                  SearchLoading ? (<CircularProgress color="secondary" />) : (null)
                }
                {
                  PhoneResult?.map(item => (
                    <p
                      onClick={() => { setSearchID(item?.id) }}
                      style={{ backgroundColor: item?.id === SearchID ? "rgb(40 216 161)" : "" }}
                      className="ResultFound">{item?.fullname}
                      <span
                        style={{
                          fontSize: "12px",
                          marginRight: "7px",
                        }}
                      >( {item?.mobile1} )</span></p>
                  ))
                }
              </div>
              {
                PhoneResult.length < 1 && Searching === true ? (
                  <div className="NotFoundMain" style={{ width: '100%' }}><p className="NotFoundMes">هیچ واحد صنعتی با این شماره پیدا نشد</p></div>
                ) : (<></>)
              }

              {
                Searching === true ? (
                  <Button onClick={() => handleSaveSearchtwo()} className="SaveSearch">ذخیره</Button>
                ) : (null)
              }
            </div>
          </div>
        </div>
      </Modal>
      <TablePagination
        rowsPerPageOptions={[10, 20, 50]}
        component="div"
        count={rowslength}
        rowsPerPage={rowsPerPage}
        page={page}
        labelRowsPerPage="تعداد نمایش :"
        nextIconButtonText="بعدی "
        backIconButtonText=" قبلی"
        onChangePage={handleChangePage}
        onChangeRowsPerPage={handleChangeRowsPerPage}
      />
    </div>
  );
}
